import "core-js/modules/es.array.push.js";
import { $h, Tips, basePost, U, baseGet, URL, SplitArray, urlParams } from '@/utils/util.js';
import zrcheader from '@/components/zrcheader/index.vue';
import zrcfooter from '@/components/zrcfooter/index.vue';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
export default {
  name: 'AboutView',
  components: {
    zrcheader,
    zrcfooter
  },
  data() {
    return {
      id: 0,
      zrctoken: '',
      catenews_list: [],
      news_list: [],
      loadingStatus: true,
      xzmenu: 1 //菜单选中
    };
  },
  created() {
    var that = this;
    this.getParams();
    setTimeout(() => {
      this.loadingStatus = false;
    }, 2000);
  },
  onLoad(option) {
    console.log('参数');
  },
  watch: {
    '$route'(to, from) {
      // 在mounted函数执行的方法，放到该处
      // 加载页面数据的方法
      var that = this;
      console.log(to.query);
      that.id = to.query.id || 1;
      that.xzmenu = that.numToStr(to.query.xzmenu) || 1;
      that.get_catenews_list(); //获取指定文章的信息
    }
  },
  methods: {
    getParams() {
      var that = this;
      // 取到路由带过来的参数
      console.log(that.$route.query);
      const option = this.$route.query;
      that.id = option.id || 1;
      that.xzmenu = that.numToStr(option.xzmenu) || 1;
    },
    numToStr(num) {
      num = num.toString();
      return num;
    },
    //获取指定文章的信息
    get_news_details: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi',
        c: 'webpublic_api',
        a: 'news_details',
        q: {
          id: that.$data.id
        }
      }, URL);
      baseGet(url, function (res) {
        that.arcinfo = res.data.info.arcinfo;
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    //获取指定文章的信息
    get_catenews_list: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi',
        c: 'webpublic_api',
        a: 'catenews_list',
        q: {
          cid: that.$data.id
        }
      }, URL);
      baseGet(url, function (res) {
        that.catenews_list = res.data.info.catenews_list;
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    //获取指定文章的信息
    get_news_list: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi',
        c: 'webpublic_api',
        a: 'news_list',
        q: {
          limit: 4
        }
      }, URL);
      baseGet(url, function (res) {
        that.news_list = res.data.info.news_list;
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    //进入到具体的新闻内容
    goxinwen: function (id, xzmenu) {
      var that = this;
      router.push({
        path: '/newsdetail',
        query: {
          id: id,
          xzmenu: xzmenu
        }
      });
    }
  },
  mounted: function () {
    var that = this;
    that.get_catenews_list(); //获取指定文章的信息
    that.get_news_list(); //获取指定文章的信息
  }
};